module.exports = __webpack_public_path__ + "static/img/6.2.3f38c92.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/6.2.png
// module id = 251
// module chunks = 0